import useMutation from 'src/hook/useMutation'
import { CommunityService } from 'src/services/community'
import {
  PutFollowMutationProps,
  PutUnfollowMutationProps
} from './usePublicCommunityMutation.types'

const usePublicCommunityMutation = () => {
  const putFollowPublicCommunityMutation = useMutation(({ communityId }: PutFollowMutationProps) =>
    CommunityService.putFollowPublicCommunity(communityId)
  )

  const putUnfollowPublicCommunityMutation = useMutation(
    ({ communityId }: PutUnfollowMutationProps) =>
      CommunityService.putUnfollowPublicCommunity(communityId)
  )

  return {
    putFollowPublicCommunityMutation,
    putUnfollowPublicCommunityMutation
  }
}

export default usePublicCommunityMutation
